import React from "react";
import { Helmet } from "react-helmet";

import Layout from "../../components/Layout";
import PageHero from "../../components/PageHero";
import Articles from "../../components/Articles";
import InfoFooter from "../../components/InfoFooter";

import heroImage from "../../img/pano_52.jpeg";

const Novinky = () => (
  <Layout>
    <Helmet
      title="Novinky | Optika Volyně"
      meta={[
        {
          name: "description",
          content:
            "Novinky a aktuality o vybavení, událostech, změnách a zboží optiky a optometrie ve městě Volyně",
        },
        {
          name: "keywords",
          content: "Optika, Optometrie, Volyně, Aktuality, Novinky, Vybavení",
        },
      ]}
    />
    <PageHero
      image={heroImage}
      alt="ilustrační foto - interiér optiky"
      title="Novinky"
      subtitle="a další zajímavosti"
    />
    <Articles />
    <InfoFooter />
  </Layout>
);

export default Novinky;
